<template>
    <div id="app" >
      <top-nav/>
      <router-view />
    </div>
  </template>

<script>
import { TopNav } from '@/components'
export default {
  name: 'NoFootLayout',
  components: {
    TopNav
  },
  data () {
    return {}
  },
  computed: {},
  created () {},
}
</script>

  <style lang="scss">
    @import "@/assets/styles/index.scss";
    @import "@/assets/mobile/index.scss";
  </style>
